import { createContext, type RefObject } from "react";

export type Theme = {
  organizationSlug: string;
  projectSlug: string;
  defaultOrganizationSlug: string;
  defaultProjectSlug: string;
  darkMode: boolean;
  setDarkMode: (value: boolean) => void;
  container: RefObject<HTMLElement | null>;
} | null;

export const ThemeContext = createContext<Theme>(null);
